<template>
  <div class="container">
    <div id="page1-div" ref="document" class="container interline border page-container">
      <div class="col-12 text-justify p-5">
        <div class="row ">

          <div class="col-12 text-center pt-2">
            <div class="ft11Black ">
              ACTA DE RECEPCIÓN DE BIENES (VEHÍCULOS)
            </div>
            <br />
            <br />
            <div class="col-12 ft11 text-right">
              GUADALAJARA, JALISCO A _________________
            </div>
          </div>
        </div>

        <div>

        </div>

        <div class="col-12 m-4 ">
          <br />
          <div class="col-12 text-center">
            <img src="./Logo-GPI.png" class="rounded covered-img" width="570px" />
          </div>
          <div class="col-12 centered">
            <span class="ft11">
              EN LA CIUDAD DE GUADALAJARA, JALISCO, SIENDO LAS ____ HORAS,
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.nombre_cliente }}
              </span>
              QUIEN SE IDENTIFICA CON LA CREDENCIAL INE DE FOLIO No. _______________, QUE LO ACREDITA COMO ARRENDATARIO
              DA CONSTANCIA DE RECIBIR EN ESTE ACTO EL VEHICULO ARRENDADO POR GPI AUTO COMERCIAL SAPI DE CV, CON NÚMERO
              DE CONTRATO
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.No_Operacion_Cliente }}
              </span>
              Y DE FECHA
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.fecha_contrato }}
              </span>.

              <br /><br />
            </span>

            <div class=" pt-3">
              <span class="ft11Black">
                DESCRIPCIÓN DEL BIEN QUE SE RECIBE:
              </span>
            </div>

            <div class="col ml-5">
              <div class="col-11 row pt-lg-3">
                <div class="col-4 text-center">
                  <span class="ft11">
                    MARCA
                  </span>
                </div>
                <div class="col-4  text-center">
                  <span class="ft11">
                    VERSION
                  </span>
                </div>
                <div class="col-4  text-center">
                  <span class="ft11">
                    MODELO
                  </span>
                </div>
              </div>
              <div class="col-11 row pt-lg-2">
                <div class="col-4 border border-dark text-center">
                  <span v-bind:class="{ marca: data.showMarca }" class="ft11">
                    {{ data.marca_vehiculo }}
                  </span>
                </div>
                <div class="col-4 border border-dark text-center">
                  <span v-bind:class="{ marca: data.showMarca }" class="ft11">
                    {{ data.año_vehiculo }}
                  </span>
                </div>
                <div class="col-4 border border-dark text-center">
                  <span class="ft11">
                    <span v-bind:class="{ marca: data.showMarca }" class="ft11">
                      {{ data.modelo_vehiculo }}
                    </span>
                  </span>
                </div>
              </div>
              <div class="col-11 row pt-lg-3">
                <div class="col-3 text-center"><span class="ft11"> </span></div>
                <div class="col-3  text-center">
                  <span class="ft11">
                    No. MOTOR
                  </span>
                </div>
                <div class="col-4  text-center">
                  <span class="ft11">
                    No. SERIE
                  </span>
                </div>
              </div>
              <div class="col-11 row pt-lg-2">
                <div class="col-2  text-center"><span class="ft11"> </span></div>
                <div class="col-4 border border-dark text-center">
                  <span v-bind:class="{ marca: data.showMarca }" class="ft11">
                    {{ data.numero_motor_vehiculo.toUpperCase() }}
                  </span>
                </div>
                <div class="col-4 border border-dark text-center">
                  <span v-bind:class="{ marca: data.showMarca }" class="ft11">
                    {{ data.numero_serie_vehiculo.toUpperCase() }}
                  </span>
                </div>
              </div>
            </div>

            <div class="col-12 ft11 pt-5">
              EL BIEN DESCRITO ANTERIORMENTE LO RECIBO DE CONFORMIDAD Y DEL CUAL SE ANEXAN IMAGENES FOTOGRAFICAS, ASÍ
              MISMO RATIFICO QUE QUEDO COMO
              DEPOSITARIO DE DICHO BIEN.
            </div>

            <div class="col-12 row pt-5">
              <div class="col-12 row pt-5">
                <div class="col-6  text-center">
                  <span class="ft11">
                    ENTREGA
                  </span>
                </div>
                <div class="col-6  text-center">
                  <span class="ft11">
                    RECIBE
                  </span>
                </div>
              </div>

              <div class="col-12 row pt-5">
                <div class="col-5  border-top border-dark text-center">
                  <span class="ft11">
                    PROVEEDOR/PROPIETARIO
                  </span>
                </div>
                <div class="col-2  text-center"></div>
                <div class="col-5  border-top border-dark text-center">
                  <span class="ft11">
                    NOMBRE DEL CLIENTE
                  </span>
                </div>
              </div>

              <div class="col-12 row pt-5">
                <div class="col-6  text-center">
                  <span class="ft11">
                    TESTIGO
                  </span>
                </div>
                <div class="col-6  text-center">
                  <span class="ft11">
                    TESTIGO
                  </span>
                </div>
              </div>

              <div class="col-12 row pt-5">
                <div class="col-5  border-top border-dark text-center">
                  <span class="ft11">

                  </span>
                </div>
                <div class="col-2  text-center"></div>
                <div class="col-5  border-top border-dark text-center">
                  <span class="ft11">

                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutYou",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    preloader() {
      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");
    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");
    }
  },
  components: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>

<style type="text/scss">
@import "./style.scss";

.covered-img {
  opacity: 0.2;
}

.container {
  position: relative;
  text-align: center;
  color: black;
}

/* Centered text */
.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/views/contratoArrendamiento/FormatoRecepcionDeBienes.vue